import { MembershipsV1BillingCycle } from '@sdk/Api'
import { type Writable, writable } from 'svelte/store'

export const billingCycle: Writable<MembershipsV1BillingCycle> = writable(
	MembershipsV1BillingCycle.BILLING_CYCLE_ANNUAL,
)
